import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Card, 
  TextField, 
  Button, 
  Typography, 
  Container,
  Alert
} from '@mui/material';
import { useAuth } from '../../context/AuthContext';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [sessionMessage, setSessionMessage] = useState('');
  const { login } = useAuth();

  // Vérifier si l'utilisateur a été déconnecté automatiquement
  useEffect(() => {
    const logoutReason = sessionStorage.getItem('logoutReason');
    if (logoutReason) {
      switch (logoutReason) {
        case 'session_expired':
          setSessionMessage('Votre session a expiré. Veuillez vous reconnecter.');
          break;
        case 'refresh_needed':
          setSessionMessage('Reconnexion nécessaire pour continuer.');
          break;
        default:
          setSessionMessage('Vous avez été déconnecté.');
      }
      sessionStorage.removeItem('logoutReason');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('/api/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await response.json();
      if (response.ok) {
        login(data.user, data.token);
      } else {
        setError(data.error || 'Erreur lors de la connexion');
      }
    } catch (err) {
      setError('Impossible de contacter le serveur');
    }
  };

  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Card sx={{ p: 4, width: '100%', backgroundColor: 'rgba(18, 18, 26, 0.8)', backdropFilter: 'blur(10px)' }}>
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
            Global TI Devis et Gestion de Projets Applicatifs
          </Typography>
          <Typography variant="body2" align="center" sx={{ mb: 4, color: 'text.secondary' }}>
            Accédez à votre espace GlobalTI
          </Typography>

          {sessionMessage && (
            <Alert 
              severity="info" 
              sx={{ mb: 3 }}
              onClose={() => setSessionMessage('')}
            >
              {sessionMessage}
            </Alert>
          )}
          
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              variant="outlined"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
            />
            <TextField
              fullWidth
              label="Mot de passe"
              type="password"
              variant="outlined"
              margin="normal"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 3 }}
            />
            
            {error && (
              <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                {error}
              </Typography>
            )}
            
            <Button
              fullWidth
              variant="contained"
              type="submit"
              size="large"
              sx={{ mt: 2 }}
            >
              Se connecter
            </Button>
          </form>
        </Card>
      </Box>
    </Container>
  );
}

export default Login;
